import { connect } from 'react-redux';

import CognitoFormAnswersScreen from '../components/CognitoFormAnswersScreen';

const mapStateToProps = (state) => {
  return {
    total: state.cognitoFormAnswers.get('total'),
    isLoading: state.cognitoFormAnswers.get('isLoading'),
  };
};

const CognitoFormAnswersScreenContainer = connect(mapStateToProps)(
  CognitoFormAnswersScreen
);

export default CognitoFormAnswersScreenContainer;
